export default __webpack_public_path__ + "static/media/alarm.4bb0efd4.svg";